<template>
  <v-breadcrumbs
    divider=">"
    :items="breadcrumbs"
  >
  </v-breadcrumbs>
</template>

<script>
import { useRouter } from "vue-router";

export default {
  name: "breadcrumbs",
  data() {
    return {
      breadcrumbs: [],
      router: null,
    };
  },
  created() {
    this.router = useRouter();
    this.router.afterEach((to, from) => {
      this.findCrumbs();
    });
    //-----------push------------------
    this.$eventBus.$on("push-crumbs", (el) => {
      if (
        typeof el === "object" &&
        (el.hasOwnProperty("href") || el.hasOwnProperty("to")) &&
        el.hasOwnProperty("title")
      ) {
        if (this.breadcrumbs.length) {
          this.breadcrumbs[this.breadcrumbs.length - 1].disabled = false;
        }

        this.breadcrumbs.push(el);
      } else {
        console.warn("unexpected format type");
      }
    });
    //-----------set------------------
    this.$eventBus.$on("set-crumbs", (el) => {
      if (Array.isArray(el)) {
        this.breadcrumbs = el;
      } else {
        console.warn("unexpected format type");
      }
    });
  },
  beforeDestroy() {
    this.$eventBus.$off("set-crumbs");
    this.$eventBus.$off("push-crumbs");
  },
  watch: {
    breadcrumbs: {
      deep: true,
      handler(breadcrumbs) {
        if (breadcrumbs.length === 0) {
          return;
        }

        const lastBreadcrumb = breadcrumbs[breadcrumbs.length - 1];

        if (lastBreadcrumb?.title) {
          document.title = lastBreadcrumb.title;
        }
      },
    },
  },
  methods: {
    findCrumbs() {
      this.breadcrumbs = [
        {
          href: this.$model.wwwroot + "/my",
          title: "Рабочий стол",
          disabled: false,
        },
      ];

      let block = {
        to: "/",
        title: this.$model.controllerName,
        disabled: false, //!this.$model.breadCrumbLink,
      };

      if (this.$route.path == "/") {
        block.disabled = true;
      }
      this.breadcrumbs.push(block);

      if (this.$route.path != "/") {
        let pathParts = this.$route.path
          .split("/")
          .filter((el) => el.length > 0);

        this.parseModules(this.$model.modules, pathParts);
        //last element
        this.breadcrumbs[this.breadcrumbs.length - 1].disabled = true;
      }
    },
    parseModules(moduleList, pathParts) {
      for (let moduleName in moduleList) {
        let index = pathParts.indexOf(moduleName);
        if (index !== -1) {
          let modulePath = {
            to: "/" + pathParts.slice(0, index + 1).join("/") + "/",
            title: moduleList[moduleName].controllerName,
            disabled: false, //moduleList[moduleName].breadCrumbLink === true ? false : true,
          };

          this.breadcrumbs.push(modulePath);

          this.parseModules(moduleList[moduleName].modules, pathParts);
        }
      }
    },
  },
};
</script>
<style lang="scss">
#procollege_vue_navigation {
  .v-breadcrumbs {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
  }
  .v-breadcrumbs.v-breadcrumbs--density-default {
    flex-wrap: wrap !important;
    white-space: normal !important;
  }
  .v-breadcrumbs-item {
    align-items: center;
    color: inherit;
    display: inline-flex;
    padding: 0 4px;
    text-decoration: none;
    vertical-align: middle;
  }
}
</style>
